export default {
  BASE_URL: '/sys/user',
  api: [
    {
      name: 'list',
      desc: '用户列表',
      method: 'GET',
      path: 'list'
    },
    {
      name: 'info',
      desc: '获取用户信息',
      method: 'GET',
      path: '/info/{id}'
    },
    {
      name: 'insert',
      desc: '新增用户',
      method: 'POST',
      path: '/add'
    },
    {
      name: 'update',
      desc: '编辑用户',
      method: 'PUT',
      path: 'edit'
    },
    {
      name: 'delete',
      desc: '删除用户',
      method: 'DELETE',
      path: '/delete/{id}'
    },
    {
      name: 'toggleInService',
      desc: '是否在职切换',
      method: 'PUT',
      path: '/status'
    },
    {
      name: 'resetPassword',
      desc: '重置密码',
      method: 'PUT',
      path: '/pwd/reset'
    },
    {
      name: 'roleList',
      desc: '获取角色列表',
      method: 'GET',
      path: '/role/list'
    },
    {
      name: 'checkName',
      desc: '校验账号名称或姓名是否重复',
      method: 'GET',
      path: '/checkName'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/system/user/index.js